import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import Image from "components/AppImage";

const BannerAdsTable = ({
  bannerAds,
  metaBannerAds,
  onEdit,
  onDelete,
  onPageChange,
}) => {
  if (!metaBannerAds) return null;

  const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = metaBannerAds;

  const TYPE_CONFIG = {
  GENERAL: {
    label: "عام",
    style: "bg-gray-100 text-gray-700"
  },
  WORKSHOP: {
    label: "ورشة",
    style: "bg-blue-100 text-blue-700"
  },
  PRODUCT: {
    label: "منتج",
    style: "bg-green-100 text-green-700"
  }
};

  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  return (
   <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-center min-w-[900px]">
          <thead className="bg-muted border-b">
            <tr>
              <th className="p-3">الصورة</th>
              <th className="p-3">العنوان</th>
              <th className="p-3">المحتوى</th>
              <th className="p-3">نوع الإعلان</th>
              <th className="p-3">الأحداث</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {bannerAds?.map((ad) => {
              const typeConfig = TYPE_CONFIG[ad.advertisement_type];

              return (
                <tr key={ad.id} className="hover:bg-muted/40 transition-smooth">
                  <td className="p-3">
                    <Image
                      src={ad?.image?.media_link}
                      className="w-16 h-16 rounded object-cover mx-auto"
                    />
                  </td>

                  <td className="p-3 font-medium">{ad.title}</td>

                  <td className="p-3 text-sm text-muted-foreground max-w-xs truncate">
                    {ad.body}
                  </td>

                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium ${typeConfig?.style}`}
                    >
                      {typeConfig?.label || "-"}
                    </span>
                  </td>

                  <td className="p-3 flex justify-center gap-2">
                    <Button
                      size="icon"
                      variant="ghost"
                      onClick={() => onEdit(ad)}
                    >
                      <Icon name="Edit" />
                    </Button>

                    <Button
                      size="icon"
                      variant="ghost"
                      onClick={() => onDelete(ad)}
                    >
                      <Icon name="Trash2" className="text-error" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
        <span className="text-sm text-text-secondary">
          {from}-{to} of {total}
        </span>

        <div className="flex gap-1 flex-wrap">
          <Button
            size="sm"
            variant="outline"
            disabled={!prev_page_url}
            onClick={() => onPageChange(current_page - 1)}
          >
            السابق
          </Button>

          {pages.map((p) => (
            <Button
              key={p}
              size="sm"
              variant={p === current_page ? "default" : "outline"}
              onClick={() => onPageChange(p)}
            >
              {p}
            </Button>
          ))}

          <Button
            size="sm"
            variant="outline"
            disabled={!next_page_url}
            onClick={() => onPageChange(current_page + 1)}
          >
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BannerAdsTable;
